var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import CatalogFragment from '../catalog-fragment';
import { ServiceChargeTargetScope } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
export let SERVICE_CHARGE_TARGET_SCOPE = /*#__PURE__*/function (SERVICE_CHARGE_TARGET_SCOPE) {
  SERVICE_CHARGE_TARGET_SCOPE["SURCHARGE_TARGET_SCOPE_DO_NOT_USE"] = "SURCHARGE_TARGET_SCOPE_DO_NOT_USE";
  SERVICE_CHARGE_TARGET_SCOPE["SURCHARGE_TARGET_SCOPE_LINE_ITEM"] = "SURCHARGE_TARGET_SCOPE_LINE_ITEM";
  SERVICE_CHARGE_TARGET_SCOPE["SURCHARGE_TARGET_SCOPE_WHOLE_PURCHASE"] = "SURCHARGE_TARGET_SCOPE_WHOLE_PURCHASE";
  return SERVICE_CHARGE_TARGET_SCOPE;
}({});
let Data = (_dec = attr('string', {
  enumClass: SERVICE_CHARGE_TARGET_SCOPE,
  protoEnum: ServiceChargeTargetScope,
  defaultValue: SERVICE_CHARGE_TARGET_SCOPE.SURCHARGE_TARGET_SCOPE_LINE_ITEM
}), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _class = class Data extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "serviceChargeTargetScope", _descriptor, this);
    _initializerDefineProperty(this, "discountId", _descriptor2, this);
    _initializerDefineProperty(this, "matchProductsId", _descriptor3, this);
    _initializerDefineProperty(this, "serviceChargeId", _descriptor4, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "serviceChargeTargetScope", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "discountId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "matchProductsId", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "serviceChargeId", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Data as default };